import { EnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { PlacedBoxesWorkstationBridge } from './bridges/placed-boxes_workstation.bridge';
import { PlacedBoxesEffects } from './effects/placed-boxes.effects';
import { PLACED_BOXES_FEATURE_KEY } from './keys';
import { placedBoxesReducer } from './reducers/placed-boxes.reducer';

export function providePlacedBoxesStore(): EnvironmentProviders[] {
    return [provideState(PLACED_BOXES_FEATURE_KEY, placedBoxesReducer), provideEffects(PlacedBoxesEffects, PlacedBoxesWorkstationBridge)];
}
